<template>
  <div class="fill-height">
    <v-container v-if="error" fill-height>
      <Error />
    </v-container>

    <div v-else>
      <v-row class="ma-0 pa-4 mb-10">
        <v-col>
          <v-row justify="start" align="center">
            <v-col class="text-start">
              <span
                class="textLight--text font-weight-medium text-h5 text-start"
              >
                {{ $t("course.myCourses") }} ({{ courses.length || 0 }})
              </span>
            </v-col>

            <v-spacer />

            <v-col cols="12" sm="6" md="4" lg="3">
              <v-text-field
                v-if="!error"
                v-model="search"
                hide-details
                prepend-inner-icon="mdi-magnify"
                color="primary"
                :placeholder="$t('course.search')"
                solo
                flat
                clearable
                :disabled="loading"
                class="shrink rounded-lg"
              />
            </v-col>
          </v-row>

          <v-row v-if="loading">
            <v-col>
              <course-card-loader />
            </v-col>
          </v-row>

          <v-row v-else-if="courses.length">
            <v-col>
              <v-row>
                <v-col>
                  <v-card flat class="rounded-lg primary--text">
                    <v-row class="ps-5 ma-0" align="center">
                      <v-col
                        v-if="$vuetify.breakpoint.smAndUp"
                        cols="6"
                        sm="4"
                        class="px-0"
                      >
                        <div class="font-weight-light text-start">
                          {{ $t("course.course") }}
                        </div>
                      </v-col>

                      <v-col
                        v-if="$vuetify.breakpoint.smAndUp"
                        cols="6"
                        sm="2"
                        class="pa-0"
                      >
                        <div class="d-flex justify-center">
                          <div class="font-weight-light">
                            {{ $t("course.assignedCourses.lessons") }}
                          </div>
                        </div>
                      </v-col>

                      <v-col cols="4" sm="2" class="px-0">
                        <div class="d-flex justify-center">
                          <v-icon
                            v-if="arrow3"
                            size="20"
                            @click="progressSorting"
                          >
                            mdi-arrow-up-thin
                          </v-icon>

                          <v-icon v-else size="20" @click="progressSorting">
                            mdi-arrow-down-thin
                          </v-icon>

                          <div
                            class="font-weight-light hand-cursor"
                            @click="progressSorting"
                          >
                            {{ $t("course.onGoingCourses.progress") }}
                          </div>
                        </div>
                      </v-col>

                      <v-col cols="4" sm="2" class="px-0">
                        <div class="d-flex justify-center">
                          <v-icon
                            v-if="arrow1"
                            size="20"
                            @click="startDateSorting"
                          >
                            mdi-arrow-up-thin
                          </v-icon>

                          <v-icon v-else size="20" @click="startDateSorting">
                            mdi-arrow-down-thin
                          </v-icon>

                          <div
                            class="font-weight-light hand-cursor"
                            @click="startDateSorting"
                          >
                            {{ $t("course.onGoingCourses.startDate") }}
                          </div>
                        </div>
                      </v-col>

                      <v-col cols="4" sm="2" class="px-0">
                        <div class="d-flex justify-center">
                          <v-icon
                            v-if="arrow2"
                            size="20"
                            @click="endDateSorting"
                          >
                            mdi-arrow-up-thin
                          </v-icon>

                          <v-icon v-else size="20" @click="endDateSorting">
                            mdi-arrow-down-thin
                          </v-icon>

                          <div
                            class="font-weight-light hand-cursor"
                            @click="endDateSorting"
                          >
                            {{ $t("course.onGoingCourses.dueDate") }}
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>

              <v-row>
                <v-col
                  cols="12"
                  v-for="(course, index) in courses"
                  :key="index"
                >
                  <course-card
                    :key="`my-course_${index}_${course._id}`"
                    :course="course"
                    :loading="loading"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row v-else justify="center" align="center">
            <v-col cols="10" sm="8" lg="6">
              <empty-courses
                :heading="$t('course.noCoursesMessage')"
                :body="$t('course.contactCoordinator')"
                :isOnSide="false"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import CourseCardLoader from "../components/skeleton-loaders/CourseCardLoader";
import Error from "../../core-module/components/Error.vue";
import EmptyCourses from "../components/EmptyCourses.vue";
import CourseCard from "../components/CourseCard.vue";

const defaultPageInput = () => ({ skip: 0, limit: 0 });

export default {
  components: {
    CourseCard,
    Error,
    EmptyCourses,
    CourseCardLoader,
  },
  data() {
    return {
      coursesOg: [],
      courses: [],
      search: "",
      error: false,
      arrow1: false,
      arrow2: false,
      arrow3: false,
      loading: true,
      pageInput: defaultPageInput(),
      filterInput: null,
      debounceSearch: null,
    };
  },
  apollo: {
    getTrainingRegistrations() {
      return {
        query: require("../api/query/getTrainingRegistrations.gql"),
        variables: this.pageInput,
        result({ data, loading }) {
          if (
            data &&
            data.getTrainingRegistrations &&
            data.getTrainingRegistrations.trainingRegistrations
          ) {
            this.coursesOg =
              data.getTrainingRegistrations.trainingRegistrations.map(obj => {
                //TODO:TRAINING: if a training have, updated or deleted module content
                obj = this.filterTrainingModulesInTrainingRegistration(obj);

                obj.days_difference = this.$moment
                  .duration(
                    this.$moment(parseInt(obj.endDate)).diff(this.$moment())
                  )
                  .asDays();

                let totalContents = 0;
                if (obj && obj.training && obj.training.trainingModules) {
                  obj.training.trainingModules.map(module => {
                    totalContents += module.trainingModuleContents.length;
                  });
                }
                obj.totalContents = totalContents ? totalContents : 0;
                obj.progress = this.getTrainingProgressPercentage(obj);
                return obj;
              });

            this.courses = this.coursesOg;
          } else {
            this.error = true;
          }

          this.loading = loading;
        },
      };
    },
  },
  watch: {
    search() {
      clearTimeout(this.debounceSearch);

      this.debounceSearch = setTimeout(() => {
        // TODO: search from api not need now, do later if need.
        // this.apiSearch();
        this.localSearch();
      }, 500);
    },
  },
  methods: {
    apiSearch() {
      const searchText = this.search?.trim() ?? "";

      if (searchText.length > 3) {
        this.filterInput = { search: searchText };

        this.$apollo.queries.getTrainingRegistrations.refetch({
          filterInput: this.filterInput,
        });
      } else if (searchText.length === 0 && this.filterInput?.search != null) {
        this.filterInput = null;

        this.$apollo.queries.getTrainingRegistrations.refetch({
          filterInput: this.filterInput,
        });
      }
    },
    localSearch() {
      const searchText = this.search?.trim()?.toLowerCase() ?? "";

      if (searchText.length > 3) {
        this.courses = this.coursesOg.reduce((result, item) => {
          if (
            item.training?.title?.findIndex(
              x =>
                x.value?.toLowerCase()?.indexOf(searchText.toLowerCase()) >= 0
            ) >= 0
          ) {
            result.push(item);
          }

          return result;
        }, []);
      } else if (searchText.length === 0) {
        this.courses = this.coursesOg;
      }
    },
    startDateSorting() {
      if (this.courses && this.courses.length) {
        if (!this.arrow1) {
          this.courses.sort((a, b) => a.startDate - b.startDate);
          this.arrow1 = true;
        } else if (this.arrow1) {
          this.courses.sort((a, b) => b.startDate - a.startDate);
          this.arrow1 = false;
        }
      }
    },
    endDateSorting() {
      if (this.courses && this.courses.length) {
        if (!this.arrow2) {
          this.courses.sort((a, b) => a.endDate - b.endDate);
          this.arrow2 = true;
        } else if (this.arrow2) {
          this.courses.sort((a, b) => b.endDate - a.endDate);
          this.arrow2 = false;
        }
      }
    },
    progressSorting() {
      if (this.courses && this.courses.length) {
        if (!this.arrow3) {
          this.courses.sort((a, b) => a.progress - b.progress);
          this.arrow3 = true;
        } else if (this.arrow3) {
          this.courses.sort((a, b) => b.progress - a.progress);
          this.arrow3 = false;
        }
      }
    },
  },
};
</script>
